import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Layout } from 'antd';
import { Debounce } from 'react-throttle';
import WindowResizeListener from 'react-window-size-listener';
import { ThemeProvider } from 'styled-components';
import appActions from '../../redux/app/actions';
import Sidebar from '../Sidebar/Sidebar';
import Topbar from '../Topbar/Topbar';
import AppRouter from './AppRouter';
import themes from '../../settings/themes';
import { themeConfig } from '../../settings';
import AppHolder from './commonStyle';
import './global.css';
import { ReactQueryDevtools } from 'react-query/devtools';
import { QueryClient } from 'react-query';
import { AppState } from '../../redux/redux.model';
import useTrackingEvents from '../../helpers/useTrackingEvents';

const { Content } = Layout;
const { toggleAll } = appActions;

const delaysInSeconds = [1, 2, 3, 5, 8];
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: delaysInSeconds.length,
      retryDelay: numberOfRetries => delaysInSeconds[numberOfRetries] * 1000,
      cacheTime: Infinity
    },
    mutations: {
      retry: delaysInSeconds.length,
      retryDelay: numberOfRetries => delaysInSeconds[numberOfRetries] * 1000
    }
  }
});

export const App = ({ match }: any) => {
  const url = match.url as string;
  const dispatch = useDispatch();
  const height = useSelector((state: AppState) => state.App.height);
  const appHeight = window.innerHeight;
  const tracking = useTrackingEvents();
  const flags = useSelector((state: AppState) => state.App.systemFlags);

  tracking.init();

  const toggleButtonRenderProps = {
    style: {
      marginBottom: '70px'
    }
  };

  return (
    <ThemeProvider theme={themes[themeConfig.theme]}>
      <AppHolder>
        <Layout style={{ height: appHeight }}>
          <Debounce time='1000' handler='onResize'>
            <WindowResizeListener onResize={windowSize => dispatch(toggleAll(windowSize.windowWidth, windowSize.windowHeight))} />
          </Debounce>
          <Topbar />
          <Layout style={{ flexDirection: 'row', overflowX: 'hidden' }}>
            <Sidebar url={url} />
            <Layout
              className='isoContentMainLayout'
              data-testid='main-layout'
              style={{
                height
              }}>
              <Content
                className='isomorphicContent'
                style={{
                  padding: '70px 0 0',
                  flexShrink: '0',
                  background: '#f1f3f6',
                  position: 'relative'
                }}>
                {flags?.ReactQueryDevTools && <ReactQueryDevtools initialIsOpen={false} toggleButtonProps={toggleButtonRenderProps} />}
                <AppRouter url={url} />
              </Content>
            </Layout>
          </Layout>
        </Layout>
      </AppHolder>
    </ThemeProvider>
  );
};
